export default __webpack_public_path__ + "static/media/neubauprojekte-wien.21f66684.svg";